import Vue from "vue";
import moment from "moment";
import { apiAuthenticationTypes, fileSelectorTypes, fileSortTypes, sourceFileTypes } from "./models/importModels";

Vue.filter("formatDate", function(value, format) {
	if (value) {
		if (format == null) return moment(String(value)).format("L");
		// if (format == "fullDate")
		//     return moment(String(value)).format('YYYY-MM-DD HH:mm');
		if (format == "fullDate") return moment(String(value)).format("L LT");
		if (format == "dayAndDate")
			return moment(String(value)).format("ddd L");
		if (format == "monthAndFullDate")
			return moment(String(value)).format("LLL");
		if (format == "monthAndDate") return moment(String(value)).format("LL");
		if (format == "dayStringMonthStringAndFullDate")
			return moment(String(value)).format("LLLL");
		if (format == "dayString") return moment(String(value)).format("ddd");
		if (format == "time") return moment(String(value)).format("LT");
		if (format == "timeAndSeconds")
			return moment(String(value)).format("LTS");
		if (format == "dayStringAndNumber")
			return moment(String(value)).format("ddd DD");
	}
	return "";
});

Vue.filter("sourceFileTypes", function(value: sourceFileTypes, culture) {
	if (value == sourceFileTypes.FOLDER) return "folder";
	if (value == sourceFileTypes.API) return "api";
	if (value == sourceFileTypes.AZURE_CLOUD) return "azure cloud";
	return value;
});

Vue.filter("apiAuthenticationTypes", function(value: apiAuthenticationTypes, culture) {
	if (value == apiAuthenticationTypes.NONE) return "nessuna";
	if (value == apiAuthenticationTypes.BEARER_TOKEN) return "token bearer";
	return value;
});

Vue.filter("fileSelectorTypes", function(value: fileSelectorTypes, culture) {
	if (value == fileSelectorTypes.ONE_FILE) return "file singolo";
	if (value == fileSelectorTypes.MULTIPLE_FILES) return "lista di files";
	if (value == fileSelectorTypes.NAME_CONTAINS) return "tutti i file che nel nome contengono";
	if (value == fileSelectorTypes.NAME_START) return "tutti i file che iniziano con";
	if (value == fileSelectorTypes.ALL_FILES) return "tutti i files";
	return value;
});

Vue.filter("fileSortTypes", function(value: fileSortTypes, culture) {
	if (value == fileSortTypes.ASC_MODIFIED_DATE) return "dal primo all'utimo per data modifica (creazione)";
	if (value == fileSortTypes.DESC_MODIFIED_DATE) return "dall'utimo al primo per data modifica (creazione)";
	if (value == fileSortTypes.ASC_ALPHABETIC) return "dal primo all'utimo in ordine alfabetico";
	if (value == fileSortTypes.DESC_ALPHABETIC) return "dall'utimo al primo in ordine alfabetico";
	return value;
});
